<template>
  <no-results
    v-if="licences.length < 1"
    title="No licences to display"
    without-icon
    padding="q-pa-md"
    align="left"
  />

  <div v-if="activeLicences.length > 0" class="q-pb-sm">
    <sticky-header static>
      Licences ({{ activeLicences.length }})
    </sticky-header>
    <div class="q-gutter-md q-px-md">
      <q-card
        v-for="(licence, key) in activeLicences"
        :key="key"
      >
        <licence-item
          :licence="licence"
          clickable
          with-expiry-date
          @click="viewingLicenceId = licence.id"
        />
      </q-card>
    </div>
  </div>

  <q-toolbar v-if="can(permissions.canManageUsers) && !readOnly">
    <q-btn
      color="green-6"
      icon-right="add"
      label="Create Licence"
      @click="$refs.addLicenceDialog.open(id)"
    />
  </q-toolbar>

  <div
    v-if="archivedLicences.length > 0"
    :class="{'q-pb-md': true, 'q-pt-md': activeLicences.length > 0}"
  >
    <sticky-header static color="red-8">
      Archived Licences ({{ archivedLicences.length }})
    </sticky-header>
    <div class="q-gutter-md q-px-md">
      <q-card
        v-for="(licence, key) in archivedLicences"
        :key="key"
      >
        <licence-item
          :licence="licence"
          clickable
          with-archived-text
          with-expiry-date
          @click="viewingLicenceId = licence.id"
        />
      </q-card>
    </div>
  </div>

  <AddLicenceDialog
    ref="addLicenceDialog"
    @created="$emit('reload')"
  />
  <ViewLicenceDialog
    :id="viewingLicenceId"
    :clickable-staff-member="false"
    @updated="updateLicence"
    @close="viewingLicenceId = null"
    @archived="onArchiveLicence($event, viewingLicenceId)"
  />
</template>

<script>
import AddLicenceDialog from 'components/app/staff/licences/partials/AddDialog'
import ViewLicenceDialog from 'components/app/staff/licences/partials/ViewDetailsDialog'

export default {
  components: {
    AddLicenceDialog, ViewLicenceDialog
  },
  props: {
    licences: {
      type: Array,
      default: () => {
        return []
      }
    },
    id: {
      type: Number,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['reload'],
  data () {
    return {
      viewingLicenceId: null
    }
  },
  computed: {
    activeLicences () {
      return this.licences.filter(item => !item.archived)
    },
    archivedLicences () {
      return this.licences.filter(item => item.archived)
    }
  },
  methods: {
    onArchiveLicence (isArchived, id) {
      const licence = this.licences.find(item => item.id === id)
      if (licence) {
        licence.archived = isArchived
      }
    },
    updateLicence (payload) {
      const index = this.licences.map(item => item.id).indexOf(payload.id)
      if (index > -1) {
        this.licences[index] = payload
      }
    }
  }
}
</script>
